import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-ens',
  templateUrl: './admin-ens.component.html',
  styleUrls: ['./admin-ens.component.css']
})
export class AdminEnsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
